/** Shared narration designation for initial cut alignment and source audition. */
// Keep this structural: the host consumes it without importing the vendor application's type graph.
export function isNarrationTrack(track: {metadata?: unknown}): boolean {
  const meta = track.metadata;
  return !!meta && typeof meta === 'object' && !Array.isArray(meta)
    && 'type' in meta && meta.type === 'audio' && 'isMainTrack' in meta && meta.isMainTrack === true
    && !('kind' in meta && meta.kind === 'bgm');
}
